<script setup lang="ts">
defineProps<{
  readonly items: ReadonlyArray<{ readonly name: string; readonly line: string }>
}>()
</script>

<template>
  <ul class="fw-welcome-modules">
    <li
      v-for="item in items"
      :key="item.name"
    >
      <strong>{{ item.name }}</strong>
      <span>{{ item.line }}</span>
    </li>
  </ul>
</template>

<style scoped>
.fw-welcome-modules {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  max-width: 520px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.fw-welcome-modules li {
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 9px;
  padding: 9px 11px;
  background: rgba(255, 255, 255, 0.05);
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12.5px;
}

.fw-welcome-modules li strong {
  /* design/current/Auth v2.dc.html satir 57: font-weight:600. <strong>'un
   * tarayici varsayilani (bolder -> 700) hicbir kural tarafindan
   * ezilmiyordu (olculdu: 700, fark +100). */
  font-weight: 600;
}

.fw-welcome-modules li span {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.66);
  line-height: 1.35;
}
</style>
